document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.harnz-category-card, .harnz-product-card').forEach((card) => {
    card.addEventListener('focus', () => card.classList.add('is-focused'));
    card.addEventListener('blur', () => card.classList.remove('is-focused'));
  });
});
/* ==========================
   HARNZ HEADER JAVASCRIPT
========================== */

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.harnz-header');
  const mobileToggle = document.querySelector('[data-harnz-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-harnz-mobile-menu]');
  const mobileClose = document.querySelector('[data-harnz-mobile-close]');

  /* Sticky header on scroll */
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) {
        header.classList.add('harnz-header--scrolled');
      } else {
        header.classList.remove('harnz-header--scrolled');
      }
    });
  }

  /* Open mobile menu */
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      mobileMenu.classList.add('is-open');
      document.body.classList.add('harnz-menu-open');
    });
  }

  /* Close mobile menu */
  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', function () {
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('harnz-menu-open');
    });
  }

  /* Close menu when clicking outside */
  document.addEventListener('click', function (event) {
    if (!mobileMenu || !mobileToggle) return;

    const clickedInsideMenu = mobileMenu.contains(event.target);
    const clickedToggle = mobileToggle.contains(event.target);

    if (!clickedInsideMenu && !clickedToggle) {
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('harnz-menu-open');
    }
  });
});
